import { useEffect, useState } from "react";

import { MEMBER_INVITE_STATUS_APPROVED, MEMBER_INVITE_STATUS_INVITED, MEMBER_INVITE_STATUS_SUBMITTED } from "../../../utils/NTGroupConstants";

import useNTGroupData from "../../../../../state/nationalTeamGroup/UseNTGroupData";

const useNTGroupAthletesFormGrid = (gridData, onSubmitFormCallback) => {
  const { onNTGroupsError } = useNTGroupData();
  const [formGridState, setFormGridState] = useState([]);
  const [excludedIdsState, setExcludedIdsState] = useState([]);

  const onInviteSelectedClicked = (event, selectedIds) => {
    try {
      event?.preventDefault();

      const updatedGroupMembers = [];

      for (const groupMemberFormObj of formGridState) {
        if (selectedIds.includes(groupMemberFormObj.personNationalTeamGroupId)) {
          updatedGroupMembers.push({
            personNationalTeamGroupId: groupMemberFormObj.personNationalTeamGroupId,
            groupAttendeeTypeId: groupMemberFormObj.groupAttendeeTypeId,
            groupRoleTypeId: groupMemberFormObj.groupRoleTypeId,
            isConfirmed: groupMemberFormObj.isConfirmed,
            inviteStatus: MEMBER_INVITE_STATUS_INVITED
          });
        }
      }

      onSubmitFormCallback(updatedGroupMembers);
    } catch (e) {
      onNTGroupsError(e);
    }
  };

  useEffect(() => {
    try {
      const newFormGridState = [];
      const newExcludedIds = [];

      for (const groupAthleteObj of gridData) {
        const newGroupAthleteFormObj = createGroupAthleteFormObj(groupAthleteObj);

        newFormGridState.push(newGroupAthleteFormObj);
        if (newGroupAthleteFormObj.canSelect === false) {
          newExcludedIds.push(newGroupAthleteFormObj.personNationalTeamGroupId);
        }
      }

      setFormGridState(newFormGridState);
      setExcludedIdsState(newExcludedIds);
    } catch (e) {
      onNTGroupsError(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridData]);

  function createGroupAthleteFormObj(groupAthleteObj) {
    return {
      personNationalTeamGroupId: groupAthleteObj.personNationalTeamGroupId,
      personId: groupAthleteObj.personId,
      groupAthleteName: `${groupAthleteObj?.preferredName || groupAthleteObj?.firstName} ${groupAthleteObj?.lastName}`,
      firstName: groupAthleteObj.firstName,
      preferredName: groupAthleteObj.preferredName,
      lastName: groupAthleteObj.lastName,
      groupAttendeeTypeId: groupAthleteObj.groupAttendeeTypeId,
      attendeeType: groupAthleteObj.attendeeType,
      groupRoleTypeId: groupAthleteObj.groupRoleTypeId,
      roleType: groupAthleteObj.roleType,
      inviteStatus: groupAthleteObj.inviteStatus,
      isConfirmed: groupAthleteObj.isConfirmed,
      canSelect: groupAthleteObj.inviteStatus !== MEMBER_INVITE_STATUS_INVITED && groupAthleteObj.inviteStatus !== MEMBER_INVITE_STATUS_SUBMITTED && groupAthleteObj.inviteStatus !== MEMBER_INVITE_STATUS_APPROVED,
      events: Array.isArray(groupAthleteObj.personNationalTeamGroupEvent) ? groupAthleteObj.personNationalTeamGroupEvent : []
    };
  }

  return {
    formGridState,
    excludedIdsState,
    onInviteSelectedClicked
  };
};

export default useNTGroupAthletesFormGrid;